function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 *  @class
 *  @function PredictiveSearchQuickSearch
 */
class PredictiveSearchQuickSearch {
    constructor() {

      this.formInputContainer = document.querySelector('.quick-search--form');

      const targetContainer = '.'+this.formInputContainer.dataset.targetContainer       
      const targetButtonID = ("targetButton" in this.formInputContainer.dataset) ?  '.'+this.formInputContainer.dataset.targetButton : '';

      this.container = document.querySelector(targetContainer);

      if(targetButtonID != '') {
          this.button = document.getElementById(targetButtonID);
      }


      this.close_button = this.container.querySelector('.thb-search-close');
      this.input = this.formInputContainer.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.container.querySelector('.thb-quick-search--results');
      this.button_mobile = document.getElementById('quick-search-mobile');
      this.setupEventListeners();
    }
  
    setupEventListeners() {
      //const form = this.container.querySelector('form.searchform');
      const form = this.formInputContainer.querySelector('form.searchform');

      form.addEventListener('submit', this.onFormSubmit.bind(this));
  
      this.input.addEventListener('input', debounce((event) => {
        if (!document.querySelector('.header-section').classList.contains('search-open')) {
          document.querySelector('.header-section').classList.toggle('search-open');
        }

        this.onChange(event);
      }, 300).bind(this));
      
        if(this.button)
        {
          this.button.addEventListener('click', (event) => {
                  var _this = this;
                  event.preventDefault();

                  if (document.querySelector('.header-section').classList.contains('search-open')) {
                      setTimeout(function() {
                          _this.input.focus({ preventScroll:true });
                      }, 100);
                  }
      
                  return false;
          });
      }

      if(this.button_mobile)  { 
        this.button_mobile.addEventListener('click', (event) => {
                var _this = this;
                event.preventDefault();
                document.querySelector('.header-section').classList.toggle('search-open');
                
                if (document.querySelector('.header-section').classList.contains('search-open')) {
                    setTimeout(function() {
                        _this.input.focus({ preventScroll:true });
                    }, 100);
                }
    
                return false;
        });
      }

  
      // Close.
      this.close_button.addEventListener('click', (event) => {
        this.close();
        event.preventDefault();
      });
      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          this.close();
        }
      });
    }
  
    categoryToggle() {
      this.category_toggle = this.container.querySelectorAll('.search-categories a');
  
      this.category_toggle.forEach((link) => {
        link.addEventListener('click', (event) => {
          this.category_toggle[0].classList.remove('active');
          this.category_toggle[1].classList.remove('active');
          link.classList.add('active');
          let target = link.getAttribute('href');
          this.container.querySelectorAll('.search-results').forEach((section) => {
            section.classList.remove('active');
          });
          this.container.querySelector(target).classList.add('active');
  
          event.preventDefault();
        });
      });
  
    }
  
    getQuery() {
      return this.input.value.trim();
    }
  
    onChange() {
      const searchTerm = this.getQuery();
  
      if (!searchTerm.length) {
        this.predictiveSearchResults.classList.remove('active');
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }
  
    onFocus() {
      const searchTerm = this.getQuery();
  
      if (!searchTerm.length) {
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();
  
      this.predictiveSearchResults.classList.add('loading');
  
      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
  
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }
  
    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
  
      this.predictiveSearchResults.classList.add('active');
  
      this.categoryToggle();
    }
  
    open() {
      document.querySelector('.header-section').classList.add('search-open');
    }
  
    close() {
      document.querySelector('.header-section').classList.remove('search-open');
    }
  }
  window.addEventListener('load', () => {
    if (typeof PredictiveSearchQuickSearch !== 'undefined') {
      new PredictiveSearchQuickSearch();
    }
  });